import ClientsAxios from '../client-axios';
import { handleGetRequest, handlePostRequest } from './requestHandler';
const { COMMUNITY_HEALTH_CAMP_SERVER } = ClientsAxios;

// Stemi
export const BeneficiaryStemiProcedureCreateService = (payload: any) =>
    handlePostRequest<any>('stemi/store', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

export const FetchStemiProcedureListService = (payload: any) =>
    handlePostRequest<any>('stemi/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// BloodBank
export const BeneficiaryBloodTestProcedureCreateService = (payload: any) =>
    handlePostRequest<any>('blood-test/store', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

export const FetchBloodTestProcedureListService = (payload: any) =>
    handlePostRequest<any>('blood-test/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Doctor Consultation
export const BeneficiaryDoctorProcedureCreateService = (payload: any) =>
    handlePostRequest<any>('doctor-consultations/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchDoctorProcedureListService = (payload: any) =>
    handlePostRequest<any>('doctor-consultations/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// OPD Consultation
export const BeneficiaryOpdProcedureCreateService = (payload: any) =>
    handlePostRequest<any>('opd-consultations/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchOpdProcedureListService = (payload: any) =>
    handlePostRequest<any>('opd-consultations/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Eye Camp Screening (Namo Netra)
export const BeneficiaryNamoNetraConsultationCreateService = (payload: any) =>
    handlePostRequest<any>('beneficiary/eye-camp-screening-store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchNamoNetraConsultationListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/eye-camp-screening-flat', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const DownloadEyeCampScreeningExcelService = (payload: any) =>
    handlePostRequest<Blob>('beneficiary/eye-camp-screening-excel', payload, COMMUNITY_HEALTH_CAMP_SERVER, {
        responseType: 'blob',
    });

// Cancer Screening (Cancer Camp)
export const BeneficiaryCancerConsultationCreateService = (payload: any) =>
    handlePostRequest<any>('cancer-screening/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchCancerConsultationListService = (payload: any) =>
    handlePostRequest<any>('beneficiary/list', { ...payload, is_cancer: true }, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchCancerScreeningDetailsService = (payload: any) =>
    handlePostRequest<any>('cancer-screening/details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchEyeScreeningDetailsService = (payload: any) =>
    handlePostRequest<any>('beneficiary/eye-camp-screening-flat', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const BeneficiaryScreeningUpdateService = (payload: any) =>
    handlePostRequest<any>('beneficiary/eye-camp-screening-update', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Diseases
export const FetchDieasesListService = (payload: any) =>
    handlePostRequest<any>('diseases/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Pharmacy
export const PharmacyConsultationStoreService = (payload: any) =>
    handlePostRequest<any>('pharmacy-consultation/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchPharmacyListService = (payload: any) =>
    handlePostRequest<any>('pharmacy-consultation/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Scheme Refer
export const FetchReferSchemeListService = (payload: any) =>
    handlePostRequest<any>('scheme-refer/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const ReferSchemeStoreService = (payload: any) =>
    handlePostRequest<any>('scheme-refer/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Referral Letter
export const StoreHospitalShareDetailService = (payload: any) =>
    handlePostRequest<any>('referral-letter/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchReferalLetterListService = (payload: any) =>
    handlePostRequest<any>('referral-letter/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// ABHA Card
export const StoreBeneficiaryAbhaCardCreateService = (payload: any) =>
    handlePostRequest<any>('abha-application/store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchBeneficiaryAbhaCardListService = (payload: any) =>
    handlePostRequest<any>('abha-application/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

// Campaign/Report
export const FetchCampaingReportService = (payload: any) =>
    handlePostRequest<any>('campaign/report', payload, COMMUNITY_HEALTH_CAMP_SERVER);
